import Component from '@glimmer/component';
import { computed } from '@ember/object';

export default class MwProgress extends Component {
  @computed('args.progress')
  get showProgress() {
    return !!this.args.progress || this.args.progress === 0;
  }
}
